var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleBoldedError = function SvgCircleBoldedError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#DB3737",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.667 11.82c0 .957-.748 1.736-1.667 1.736s-1.667-.78-1.667-1.736c0-.958.748-1.737 1.667-1.737s1.667.78 1.667 1.736M6.527 2.99l.283 5.903a.51.51 0 0 0 .499.495H8.69a.51.51 0 0 0 .5-.495l.283-5.903a.51.51 0 0 0-.5-.547H7.026a.51.51 0 0 0-.5.547"
  })));
};
export default SvgCircleBoldedError;